import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiMail, FiArrowRight, FiLoader, FiCheckCircle } from "react-icons/fi";
import AuthLayoutWrapper from "../../components/auth/AuthCardWrapper";
import { InputField } from "../../components/FormFields";
import api from "../../api/axios";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [toastMsg, setToastMsg] = useState("");
  const [error, setError] = useState({ email: "" });

  const navigate = useNavigate();

  const isValidEmail = (emailStr) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailStr);
  };

  const handleInputChange = (e) => {
    setEmail(e.target.value);
    if (error.email) {
      setError((prev) => ({ ...prev, email: "" }));
    }
    if (errorMsg) {
      setErrorMsg("");
    }
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setError({ email: "Email is required" });
      return;
    } else if (!isValidEmail(email)) {
      setError({ email: "Invalid email format" });
      return;
    }

    setErrorMsg("");
    setError({ email: "" });
    setLoading(true);

    try {
      const response = await api.post("/auth/send-otp", { email });

      if (response) {
        sessionStorage.setItem("reset_email", email);
        setToastMsg("OTP sent successfully!");

        // Show toast briefly before navigating
        setTimeout(() => {
          navigate("/auth/verify-otp");
        }, 800);
      }
    } catch (err) {
      setErrorMsg(
        err.response?.data?.message || "Failed to send code. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayoutWrapper>

      {/* Header Section */}
      <div className="mb-4 text-center">
        <h3 className="text-3xl font-extrabold text-[#111827]">
          Forgot Password
        </h3>
        <p className="mt-1 text-xs font-semibold text-[var( --color-primary)]">
          Enter your email to receive an OTP verification code
        </p>
      </div>

      {/* API Error Container */}
      {errorMsg ? (
        <div className="mb-3 rounded-lg bg-red-50 p-2.5 text-center text-xs font-medium text-red-600">
          {errorMsg}
        </div>
      ) : null}

      <form
        onSubmit={handleSendOtp}
        className="mb-4 flex flex-1 flex-col justify-between gap-5"
      >
        <div>
          <InputField
            label="Email address"
            name="email"
            type="email"
            onChange={handleInputChange}
            value={email}
            placeholder="Enter your email"
            icon={<FiMail className="text-[#111827]" />}
            error={error.email}
          />
        </div>

        <div className="space-y-3">
          {/* Submit Button with Animated Loader */}
          <button
            type="submit"
            disabled={loading}
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#1A1A1A] py-3 text-xs font-bold tracking-wider text-[#FFFFFF] transition-all hover:bg-[#11172E] active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-70"
          >
            {loading ? (
              <>
                <FiLoader className="animate-spin text-base" />
                <span>SENDING OTP...</span>
              </>
            ) : (
              <>
                <span>SEND OTP</span>
                <FiArrowRight className="text-sm" />
              </>
            )}
          </button>

          <div className="text-center">
            <button
              type="button"
              onClick={() => navigate("/auth/sign-in")}
              className="text-xs font-semibold text-[#374151] hover:underline"
            >
              Back to Log In
            </button>
          </div>
        </div>
      </form>
    </AuthLayoutWrapper>
  );
}